export default __webpack_public_path__ + "static/drone-75734245224e2c815b0595e46bf7ee6a.jpg";